import { render, staticRenderFns } from "./EmptyPhotosCard.vue?vue&type=template&id=4c060c4e&scoped=true"
import script from "./EmptyPhotosCard.vue?vue&type=script&lang=js"
export * from "./EmptyPhotosCard.vue?vue&type=script&lang=js"
import style0 from "./EmptyPhotosCard.vue?vue&type=style&index=0&id=4c060c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c060c4e",
  null
  
)

export default component.exports